module.exports = __webpack_public_path__ + "selo-qualidade-maxima.png";